/**
 * SbTooltip - Wrapper around Ant Design Tooltip
 *
 * Provides a consistent tooltip component across the application.
 * Centralizes tooltip behavior and styling.
 *
 * Props:
 *   - content   : Tooltip body (alias for AntD `title`). Wins over `title` when both provided.
 *   - title     : Backwards-compat alias for `content`.
 *   - delay     : Mouse-enter delay in milliseconds before showing tooltip. Default 200ms.
 *                 Passed through as `mouseEnterDelay={delay / 1000}`.
 *   - maxWidth  : Max width (px) of the tooltip overlay. Default 300.
 *   - disabled  : When true, returns children unwrapped — no tooltip attaches.
 *
 * @example
 * import { SbTooltip } from 'uiCore';
 *
 * <SbTooltip content="Helpful text">
 *   <button>Hover me</button>
 * </SbTooltip>
 */

import React from 'react';
import { Tooltip } from 'antd';

const SbTooltip = ({
  children,
  content,
  title,
  delay = 200,
  maxWidth = 300,
  disabled = false,
  ...props
}) => {
  if (disabled) return <>{children}</>;

  return (
    <Tooltip
      title={content ?? title}
      mouseEnterDelay={delay / 1000}
      overlayStyle={{ maxWidth }}
      {...props}
    >
      {children}
    </Tooltip>
  );
};

export default SbTooltip;
